import { updateGlobalEntities } from './index';

export const setCurrentSubPaymentMethod = (subPaymentMethod) => {
  return (dispatch, getState) => {
    return dispatch(updateGlobalEntities({
      currentSubPaymentMethod: subPaymentMethod
    }));
  };
};
export const setTotalPriceSummary = (total) => {
  return (dispatch, getState) => {
    return dispatch(updateGlobalEntities({
      finalSummaryPrice: total
    }));
  };
};

export const setShouldChangeFavoritePaymentMethod = (flag) => {
  return (dispatch, getState) => {
    return dispatch(updateGlobalEntities({
      shouldChangeFavoritePaymentMethod: flag
    }));
  };
};

